import { Close } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Alert, Avatar, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Scrollbar } from 'app/components';
import { TransportRoundedIcon } from 'app/icons';
import { TrailerForm } from 'app/pages/Trailer';
import { useAsyncAction } from 'app/services';
import { trailerCreate } from 'app/store/trailer';
import React, { useEffect, useRef } from 'react';

const TrailerDialog = (props) => {
  const formRef = useRef();
  const { open, onClose } = props;

  const {
    asyncAction: createSubmit,
    isLoading: isCreateLoading,
    isSuccessful: isCreateSuccessful,
    isError: isCreateError,
  } = useAsyncAction(trailerCreate, [open]);

  const handleFormClick = () => {
    formRef.current?.handleFormSubmit();
  };

  const handleFormSubmit = (params) => {
    createSubmit(params);
  };

  useEffect(() => {
    if (isCreateSuccessful) {
      onClose();
    }
  }, [isCreateSuccessful]);

  return (
    <Dialog
      maxWidth='lg'
      open={open}
      onClose={onClose}
      sx={(theme) => ({
        width: '100%',
        height: '100%',
        '.MuiDialog-paper': {
          minWidth: '540px',
        },
        '.MuiDialogTitle-root': {
          display: 'flex',
          padding: theme.spacing(2),
          alignItems: 'center',
        },
        '.MuiDialogTitle-root .MuiTypography-root': {
          marginLeft: theme.spacing(2),
        },
        '.MuiDialogTitle-root .MuiButtonBase-root': {
          marginLeft: 'auto',
        },
        '.MuiDialogContent-root': {
          padding: theme.spacing(0),
        },
        '.MuiDialogContent-root .simplebar-container': {
          padding: theme.spacing(0, 2),
        },
        '.MuiDialogActions-root': {
          padding: theme.spacing(2),
          justifyContent: 'flex-end',
        },
        '.MuiAvatar-circular': {
          bgcolor: alpha(theme.palette.primary.main, 0.12),
          svg: {
            width: '18px',
            height: '18px',
          },
          path: {
            fill: theme.palette.primary.main,
          },
        },
        '.MuiAlert-root': {
          marginTop: theme.spacing(1),
          marginBottom: theme.spacing(2),
          borderRadius: theme.shape.borderRadius,
        },
      })}>
      <DialogTitle>
        <Avatar>
          <TransportRoundedIcon fontSize='small' />
        </Avatar>
        <Typography component='span'>Добавить прицеп</Typography>
        <IconButton color='default' onClick={onClose}>
          <Close fontSize='small' />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Scrollbar>
          <TrailerForm ref={formRef} onSubmit={handleFormSubmit} />
          {isCreateError && (
            <Alert severity='error'>
              Произошла ошибка при добавлении прицепа. Попробуйте снова или обратитесь в техническую поддержку.
            </Alert>
          )}
        </Scrollbar>
      </DialogContent>
      <DialogActions>
        <LoadingButton variant='contained' loading={isCreateLoading} onClick={handleFormClick} disableElevation>
          Добавить
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default TrailerDialog;
